import axios from "axios";
import ValidateTokenExistence from "../../middlewares/ValidateTokenExistence";
import { manejarSesionRechazada } from "../../middlewares/SesionRechazada";

export class BaseParticipanteService {
  axiosClient;

  constructor() {
    this.axiosClient = axios.create({
      baseURL: `${process.env.REACT_APP_SERVER_PART}`,
    });
    this.initAxiosInterceptor();
  }

  initAxiosInterceptor() {
    this.axiosClient.interceptors.response.use((respuesta: any) => respuesta, manejarSesionRechazada);
    this.axiosClient.interceptors.request.use(async (config) => {
      try {
        const token = localStorage.getItem("token");
        await ValidateTokenExistence(config, token)
        return config;
      } catch (error) {
        /*
          No se traga el error: devolver undefined dejaba salir la peticion
          sin cabecera de autorizacion, el backend respondia 400 "Error no hay
          token" y ese mensaje se lee como sesion rechazada, asi que no poder
          adjuntar el token terminaba cerrando la sesion.
        */
        return Promise.reject(error);
      }
    });
  }
}
